import { useMemo } from 'react';
import ReusableCard from '../../../Common/ReusableCard';
import { LuBuilding2 } from 'react-icons/lu';
import { FaCar } from 'react-icons/fa';

const DashboardCards = ({ vehicles = [], requests = [], loading = false }) => {

  // Transform vehicles data to match ReusableCard format
  const transformedVehicles = useMemo(() => vehicles.map((vehicle, index) => ({
    title: vehicle.vehicle_regno,
    description: `Vehicle - Installed on ${new Date(vehicle.installation_date).toLocaleDateString()}`,
    id: vehicle.vehicle_regno || index
  })), [vehicles]);

  // Transform requests data to match ReusableCard format
  const transformedRequests = useMemo(() => requests.map((request, index) => ({
    title: request.company_name || "",
    description: `${request?.request_type ?? ""} - ${new Date(request.created_at).toLocaleDateString()}`,
    id: `request-${index}`
  })), [requests]);

  // Render function for vehicles
  const renderItem = (item, isLast) => {
    return (
      <div key={item.id} className={`d-flex align-items-center justify-content-between px-2 py-3 card-item ${!isLast ? 'border-bottom' : ''}`}>
        <div className="d-flex align-items-center">
          {String(item?.id)?.startsWith('request') ? <LuBuilding2 className="text-muted me-3" size={16} /> : <FaCar className="text-muted me-3" size={16} />}
          <div>
            <div className="fw-semibold text-capitalize text-dark">{item.title}</div>
            {item.description ? <div className="text-muted small">{item.description}</div> : null}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="row mt-4">
      {/* Newly Added Vehicles Card */}
      <ReusableCard
        className='col-md-6'
        heading="Newly Added Vehicles"
        data={transformedVehicles}
        link="/vehicles"
        linkText="View All"
        loading={loading}
        emptyMessage="No vehicles found"
        renderItem={renderItem}
      />

      {/* Recent Requests Card */}
      <ReusableCard
        className='col-md-6'
        heading="Recent Requests"
        data={transformedRequests}
        link="/companys/requests"
        linkText="View All"
        loading={loading}
        emptyMessage="No requests found"
        renderItem={renderItem}
      />
    </div>
  );
};

export default DashboardCards; 